import { addSentryBreadcrumb } from '../../shared/sentry/sentryUser';

type CommissionOp =
  | 'settlement_create'
  | 'settlement_approve'
  | 'settlement_pay'
  | 'settlement_void'
  | 'settlement_cancel'
  | 'plan_save'
  | 'advance_register';

export function breadcrumbCommission(
  op: CommissionOp,
  message: string,
  data?: Record<string, unknown>,
): void {
  addSentryBreadcrumb('commissions', message, 'info', {
    op,
    module: 'commissions',
    ...data,
  });
}
